define.alias("ember-composable-helpers/helpers/keys", "settings/helpers/keys");